export default __webpack_public_path__ + "static/blobedFeature2-a62e42d866fa24804d965c3b93a3e7af.png";